export class Item {
  id: string;
}



// WEBPACK FOOTER //
// ./src/app/model/item.ts